module.exports = __webpack_public_path__ + "static/media/D .ff2f1430.svg";